import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@env';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(value: Date | string | null | undefined, dateFormat?: string): string | null {
    const format = dateFormat ?? environment.dateFormat;
    return this.datePipe.transform(value, format);
  }
}
